// Win98 helpers: threshold-based header tint
const WIN98 = (() => {
  const THRESHOLD = 1; // px before applying header tint
  const body = document.body;

  const onScroll = () => {
    if (window.scrollY > THRESHOLD) {
      body.classList.add('win98-scrolled');
    } else {
      body.classList.remove('win98-scrolled');
    }
  };

  const init = () => {
    // Run once and bind
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
